import { ChevronRight } from "lucide-react";
import { useTranslate } from "ra-core";
import type { ReactNode } from "react";

/**
 * «Ещё»: the rarely used fields of a form, folded away so the form shows only
 * what a manager fills in every day. Opens by itself when one of them is set.
 */
export const MoreFields = ({
  children,
  defaultOpen = false,
}: {
  children: ReactNode;
  defaultOpen?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <details className="group" open={defaultOpen}>
      <summary className="flex w-fit cursor-pointer list-none items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground [&::-webkit-details-marker]:hidden">
        <ChevronRight className="size-4 transition-transform group-open:rotate-90" />
        {translate("crm.common.more_fields")}
      </summary>
      <div className="mt-4 flex flex-col gap-4">{children}</div>
    </details>
  );
};
